import { useState, ChangeEvent } from "react"
import Button from "../../component/button/button"
import { IoArrowBack } from "react-icons/io5"
import { useLocation, useNavigate } from "react-router-dom"
import CustomInput from "src/component/CustomInput/CustomInput"
import { resetPassword } from "src/api/auth"

const SetPassword = () => {
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const navigate = useNavigate()
  const location = useLocation()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (loading) return

    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e: any) => {
    const { email, token } = location.state || {}
    e.preventDefault()
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters")
      return
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match")
      return
    }
    setError("")

    setLoading(true)
    resetPassword(email, token, form.password)
      .then((res) => {
        navigate("/login")
      })
      .catch((err) => {
        console.log({ err })
        setError("Failed to reset password. Please try again.")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div className='content login'>
      <div className='login_container'>
        <h2 className='title'>Set new password</h2>
        <p>Must be at least 8 characters.</p>

        <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
          <CustomInput
            placeholder='Password'
            type='password'
            name='password'
            value={form.password}
            onChange={handleChange}
            error={error.includes("characters") ? error : ""}
          />

          <CustomInput
            placeholder='Confirm password'
            type='password'
            name='confirmPassword'
            value={form.confirmPassword}
            onChange={handleChange}
            error={error.includes("match") ? error : ""}
          />

          <Button
            text={loading ? "Setting..." : "Set Password"}
            style={{ marginTop: 12 }}
            type='secondary'
            buttonType='submit'
          />
        </form>

        {error && !error.includes("characters") && !error.includes("match") && (
          <p className='text-red-500 text-sm mt-2'>{error}</p>
        )}

        <p
          className='no_account cursor-pointer mt-4'
          onClick={() => navigate("/login")}
        >
          <IoArrowBack /> Back to log in
        </p>
      </div>
    </div>
  )
}

export default SetPassword
